import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WatermarkService } from '../../../core/services/watermark.service';

@Component({
  selector: 'app-watermark',
  template: `
    <div class="watermark-overlay" 
         *ngIf="estVisible" 
         [attr.data-texte]="texteWatermark">
    </div>
  `,
  styleUrls: ['./watermark.component.scss'],
  standalone: false
})
export class WatermarkComponent implements OnDestroy {
  public texteWatermark = '';
  public estVisible = false;

  private readonly detruire$ = new Subject<void>();

  constructor(private readonly watermarkService: WatermarkService) {
    this.watermarkService.texte$
      .pipe(takeUntil(this.detruire$))
      .subscribe(texte => this.texteWatermark = texte);

    this.watermarkService.estVisible$
      .pipe(takeUntil(this.detruire$))
      .subscribe(visible => this.estVisible = visible);
  }

  public ngOnDestroy(): void {
    this.detruire$.next();
    this.detruire$.complete();
  }
}